import { c as _c } from "react/compiler-runtime";
import { Button } from '@systemeio/components';
import { Trash02Icon } from '@systemeio/icons';
import { removeSplitTest } from 'modules/funnels/funnel/api/funnel-api';
import { SplitTestPeriod } from 'modules/funnels/funnel/components/split-tests-tab/split-test-period';
import { TabContentLoader } from 'modules/funnels/funnel/components/tab-content-loader';
import TabTable from 'modules/funnels/funnel/components/tab-table';
import { useFunnelStepTestsHistory } from 'modules/funnels/funnel/hooks/use-funnel-step-tests-history';
import { useSplitTestTableColumns } from 'modules/funnels/funnel/hooks/use-split-test-table-columns';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { getHistoryTableData } from 'modules/funnels/funnel/utils/split-tests-utils';
import React, { useState } from 'react';
import Confirmation from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface SplitTestHistoryProps {
  funnelStep: FunnelStepInterface;
}
function SplitTestHistory(t0) {
  const $ = _c(25);
  const {
    funnelStep
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    testsHistoryData,
    mutateHistoryData
  } = useFunnelStepTestsHistory(funnelStep.id);
  const [isFetching, setIsFetching] = useState(false);
  const [isDeleteHistoryItemOpen, setIsDeleteHistoryItemOpen] = useState(false);
  const [historyItemIdToDelete, setHistoryItemIdToDelete] = useState(null);
  let t1;
  if ($[0] !== funnelStep.id || $[1] !== historyItemIdToDelete || $[2] !== mutateHistoryData) {
    t1 = async () => {
      if (!historyItemIdToDelete) {
        setIsDeleteHistoryItemOpen(false);
        return;
      }
      setIsFetching(true);
      const response = await removeSplitTest(funnelStep?.id, historyItemIdToDelete);
      await mutateHistoryData(response.data, false);
      setHistoryItemIdToDelete(null);
      setIsFetching(false);
    };
    $[0] = funnelStep.id;
    $[1] = historyItemIdToDelete;
    $[2] = mutateHistoryData;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleDeleteHistoryItem = t1;
  const columns = useSplitTestTableColumns();
  if (!testsHistoryData || isFetching) {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <TabContentLoader />;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] !== columns || $[6] !== t || $[7] !== testsHistoryData) {
    const tableData = getHistoryTableData(testsHistoryData);
    t2 = tableData.length > 0 && <div className="tablet:gap-5 flex flex-col gap-4"><h2 className="text-text-primary text-xl font-semibold">{t("dashboard.funnel.split_tests.history_header")}</h2><div className="tablet:gap-5 flex flex-col gap-4">{tableData.map(historyItem => <div className="flex flex-col gap-2" key={historyItem.splitTest.id}><SplitTestPeriod splitTest={historyItem.splitTest} action={<Button aria-label={t("global.delete")} onClick={() => {
            setHistoryItemIdToDelete(historyItem.splitTest.id);
            setIsDeleteHistoryItemOpen(true);
          }} size="icon-sm" variant="ghost-gray"><Trash02Icon /></Button>} /><TabTable columns={columns} data={historyItem} /></div>)}</div></div>;
    $[5] = columns;
    $[6] = t;
    $[7] = testsHistoryData;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t) {
    t3 = t("dashboard.funnel.split_tests.remove_action_history_confirmation_text");
    $[9] = t;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsDeleteHistoryItemOpen(false);
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t) {
    t5 = t("dashboard.funnel.split_tests.remove_action_history_toast");
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("global.delete");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== handleDeleteHistoryItem || $[17] !== isDeleteHistoryItemOpen || $[18] !== t3 || $[19] !== t5 || $[20] !== t6) {
    t7 = <Confirmation status="error" confirmationText={t3} opened={isDeleteHistoryItemOpen} onClose={t4} onConfirm={handleDeleteHistoryItem} toastCaption={t5} confirmButtonCaption={t6} />;
    $[16] = handleDeleteHistoryItem;
    $[17] = isDeleteHistoryItemOpen;
    $[18] = t3;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t2 || $[23] !== t7) {
    t8 = <>{t2}{t7}</>;
    $[22] = t2;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}
export default SplitTestHistory;